module.exports = __webpack_public_path__ + "img/L_296_0.3b627387.png";